import React from "react";
import { Link } from "react-router-dom";
import Blog_1 from "../../../assets/images/home_page_6/blog/01.png";
import Blog_2 from "../../../assets/images/home_page_6/blog/02.png";
import Blog_3 from "../../../assets/images/home_page_6/blog/03.png";

const blogPosts = [
    {
        id: 1,
        title: "The Importance of Soil Health in Agricultural Production",
        img: Blog_1,
        date: "15",
        month: "March",
        comments: 5,
        author: "Admin",
    },
    {
        id: 2,
        title: "Pest Management in Agriculture Natural and Chemical Solutions",
        img: Blog_2,
        date: "15",
        month: "March",
        comments: 5,
        author: "Admin",
    },
    {
        id: 3,
        title: "The Role of Genetics in Modern Agricultural Production",
        img: Blog_3,
        date: "15",
        month: "March",
        comments: 5,
        author: "Admin",
    },
];

const Blog = () => {
    return (
        <section id="blog-six" className="blog-six-main-block">
            <div className="container">
                <div className="section text-center">
                    <h3 className="section-heading">Discover Your Digital Dreams</h3>
                    <p>
                        For your car, we will do everything—advice, repairs, and maintenance. We
                        are the preferred choice by many car owners because our experience
                        and knowledge are self-evident.
                    </p>
                </div>
                <div className="row">
                    {blogPosts.map((blog) => (
                        <div key={blog.id} className="col-lg-4 col-md-4">
                            <div className="blog-six-block">
                                <div className="blog-six-img">
                                    <Link to="/BlogDetails" title="">
                                        <img src={blog.img} className="img-fluid" alt={blog.title} />
                                    </Link>
                                    <span className="badge text-bg-primary">
                                        <span>{blog.date}</span>
                                        <br />
                                        {blog.month}
                                    </span>
                                </div>
                                <div className="blog-six-dtl">
                                    <ul className="blog-tags">
                                        <li>
                                            <Link to="/BlogDetails" title="">
                                                <i className="flaticon-comment-1" /> Comments ({blog.comments})
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/BlogDetails" title="">
                                                <i className="flaticon-avatar" /> By {blog.author}
                                            </Link>
                                        </li>
                                    </ul>
                                    <h6 className="blog-six-title">
                                        <Link to="/BlogDetails" title="">{blog.title}</Link>
                                    </h6>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Blog;
